<script lang="ts">
  /**
   * "Skool ↗" — the one way this product points at Skool.
   *
   * Lifted verbatim out of `<SkoolPost>`, which had the only copy. It is here because
   * the same affordance is wanted on a MEMBER: a card, a drawer header or a row names
   * somebody, and the next thing anyone wants is their actual profile. Re-typing the
   * anchor at each site is how one of them ends up without `rel="noopener"`, or
   * navigating the Helper's own panel away instead of the tab beside it.
   *
   * `followLink` is the whole reason it cannot be a plain `<a>`: the admin app opens a
   * tab, and the Helper's side panel points the Skool tab next to it at the URL rather
   * than replacing itself — it IS its own current tab, and a naked anchor there closes
   * the panel the owner is working in. `target="_blank"` stays as the fallback and as
   * what keeps cmd-click honest.
   */
  import { followLink } from './host';

  let {
    href,
    label = 'Skool',
    title = 'Open on Skool',
  }: {
    /** Null renders nothing: a link to nowhere is worse than no link. A member with no
     *  handle has no profile URL, and that is a real case rather than an error. */
    href: string | null | undefined;
    label?: string;
    title?: string;
  } = $props();
</script>

{#if href}
  <a
    {href}
    target="_blank"
    rel="noopener noreferrer"
    onclick={(e) => followLink(e, href)}
    class="inline-flex shrink-0 items-center gap-1 transition-colors hover:text-primary"
    {title}
  >
    {label}
    <svg class="h-3 w-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7" /><polyline points="7 7 17 7 17 17" /></svg>
  </a>
{/if}
